import React, { useState, Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { FiTrash2 } from 'react-icons/fi'
import { IoIosWarning, IoMdClose } from 'react-icons/io'
import toast from 'react-hot-toast'

import { useDeleteBankAccountMutation } from '../../../features/account/bankSlice'
import { IBank } from './types'

export const DeleteAccountModal = ({ bank }: { bank: IBank }) => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false)

  const [deleteAccount, { isLoading, isSuccess }] =
    useDeleteBankAccountMutation()

  const handleDelete = async () => {
    try {
      toast.loading('Deleting account...')
      setIsDeleteModalOpen(false)
      await deleteAccount({ id: bank._id })
      toast.dismiss()
      toast.success('Account deleted successfully!')
    } catch (error: any) {
      toast.dismiss()
      toast.error(error?.data.message)
    }
  }

  return (
    <div className='mt-1'>
      <button onClick={() => setIsDeleteModalOpen(true)}>
        <FiTrash2 className='text-lg text-red-500 box-content p-2 rounded-lg hover:bg-gray-500 cursor-pointer' />
      </button>

      <Transition appear show={isDeleteModalOpen} as={Fragment}>
        <Dialog
          as='div'
          className='relative z-50'
          onClose={() => setIsDeleteModalOpen(false)}
        >
          <Transition.Child
            as={Fragment}
            enter='ease-out duration-300'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'
          >
            <div className='fixed inset-0 bg-black/40 backdrop-blur-sm' />
          </Transition.Child>

          <div className='fixed inset-0 overflow-y-auto'>
            <div className='flex min-h-full items-center justify-center p-4 text-center'>
              <Transition.Child
                as={Fragment}
                enter='ease-out duration-300'
                enterFrom='opacity-0 scale-95'
                enterTo='opacity-100 scale-100'
                leave='ease-in duration-200'
                leaveFrom='opacity-100 scale-100'
                leaveTo='opacity-0 scale-95'
              >
                <Dialog.Panel className='relative font-dashboard w-full max-w-2xl min-h-[400px] transform overflow-hidden rounded-2xl bg-[#161819] px-4 pt-4 pb-10 text-left align-middle shadow-xl transition-all'>
                  <div className='flex justify-center py-4'>
                    <div className='flex flex-col items-center gap-2'>
                      <IoIosWarning className='text-8xl text-yellow-500' />
                      <p className='text-lg md:text-xl text-center font-light text-white/80'>
                        Are you sure want to delete this account?
                      </p>
                      <p className='text-sm font-light text-white/50'>
                        {bank.bankName} | Account no.{' '}
                        {`${bank.accountNumber.substring(
                          0,
                          2
                        )}*****${bank.accountNumber
                          .toString()
                          .substring(bank.accountNumber.length - 4)}`}
                      </p>

                      <div className='flex items-center gap-4 mt-8'>
                        <button
                          className='transition-all duration-200 px-6 py-2 rounded-full text-sm bg-red-500 hover:bg-red-600 text-white'
                          onClick={handleDelete}
                        >
                          Yes, delete it
                        </button>
                        <button
                          className='transition-all duration-200 px-6 py-2 rounded-full text-sm bg-white/80 hover:bg-white text-black'
                          onClick={() => setIsDeleteModalOpen(false)}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  )
}
